import React, { useState } from 'react';

import { Modal } from '../../../../components';

import { BlackShoppingCart } from '../../../../assets/svg-image/modal';

import SquadBoldText from '../../../../components/Text/SquadBoldText';
import PingFangSemiBoldText from '../../../../components/Text/PingFangSemiBoldText';
import SquadRegularText from '../../../../components/Text/SquadRegularText';
import RowCenter from '../../../../components/Layout/RowCenter';
import { closeBlack } from '../../../../assets/Base64Image';
import Button from '../../../../components/Button';
import ColumnCenter from '../../../../components/Layout/ColumnCenter';
import Column from '../../../../components/Layout/Column';
import CreditOrDebitCard from './CreditOrDebitCard';
import ApplePay from './ApplePay';
import GooglePay from './GooglePay';
import AliPay from './AliPay';
import WechatPay from './WechatPay';

const SelectPaymentMethodModal: React.FC<Props> = ({
  onClose,
  onConfirm,
  isEnglish,
}) => {
  const [paymentMethod, setPaymentMethod] = useState<string>();

  return (
    <Modal
      style={{ width: 303, minWidth: 'unset', padding: 'unset', paddingBottom: 26, borderRadius: 42 }}
    >
      {/* 图标 */}
      <RowCenter>
        <img src={BlackShoppingCart} style={{ width: '72px', height: '71px', marginTop: '-35px' }} />
      </RowCenter>
      {/* 关闭图标 */}
      <Button
        onClick={() => onClose()}
        style={{ padding: 10, width: 30, height: 30, marginLeft: 'auto', marginRight: 10, marginTop: -10 }}
      >
        <img src={closeBlack} style={{ width: 14, height: 14 }} />
      </Button>

      <RowCenter>
        {
          isEnglish ? (
            <SquadBoldText fontSize={22} letterSpacing={1} marginTop={5}>
              Select payment method
            </SquadBoldText>
          ) : (
            <PingFangSemiBoldText fontSize={22} letterSpacing={1} marginTop={5}>
              选择支付方式
            </PingFangSemiBoldText>
          )
        }
      </RowCenter>

      <RowCenter>
        <Column style={{ width: 277, marginTop: 20 }}>
          {/* 银行卡 */}
          <CreditOrDebitCard
            marginTop={15}
            isEnglish={isEnglish}
            paymentMethod={paymentMethod}
            setPaymentMethod={setPaymentMethod}
          />
          {/* 苹果支付 */}
          <ApplePay
            marginTop={10}
            isEnglish={isEnglish}
            paymentMethod={paymentMethod}
            setPaymentMethod={setPaymentMethod}
          />
          {/* 谷歌支付 */}
          <GooglePay
            marginTop={10}
            isEnglish={isEnglish}
            paymentMethod={paymentMethod}
            setPaymentMethod={setPaymentMethod}
          />
          {/* 微信支付 */}
          <WechatPay
            marginTop={10}
            isEnglish={isEnglish}
            paymentMethod={paymentMethod}
            setPaymentMethod={setPaymentMethod}
          />
          {/* 支付宝支付 */}
          <AliPay
            marginTop={10}
            isEnglish={isEnglish}
            paymentMethod={paymentMethod}
            setPaymentMethod={setPaymentMethod}
          />
        </Column>
      </RowCenter>

      <RowCenter>
        <Button width={265} height={52} borderRadius={60} border={'1px solid #00B595'} boxShadow={'0px 22px 30px 0px rgba(0,181,149,0.05)'} backgroundColor={paymentMethod ? '#00B595' : '#FFFFFF'} marginTop={15} onClick={() => onConfirm()}>
          {
            isEnglish ? (
              <ColumnCenter>
                <SquadBoldText fontSize={18} lineHeight={21} color={paymentMethod ? '#FFFFFF' : '#00B595'} letterSpacing={1}>
                  Complete payment
                </SquadBoldText>
                <SquadRegularText fontSize={18} lineHeight={21} color={paymentMethod ? '#FFFFFF' : '#00B595'} letterSpacing={1}>
                  $2.00
                </SquadRegularText>
              </ColumnCenter>
            ) : (
              <ColumnCenter>
                <PingFangSemiBoldText fontSize={18} lineHeight={23} color={paymentMethod ? '#FFFFFF' : '#00B595'} letterSpacing={1}>
                  完成方式
                </PingFangSemiBoldText>
                <SquadRegularText fontSize={18} lineHeight={21} color={paymentMethod ? '#FFFFFF' : '#00B595'} letterSpacing={1}>
                  $2.00
                </SquadRegularText>
              </ColumnCenter>
            )
          }
        </Button>
      </RowCenter>
    </Modal>
  );
};

export interface Props {
  onClose: () => void;
  onConfirm: () => void;
  isEnglish: boolean;
}

export default SelectPaymentMethodModal;
